export default {
  // KakaoProfile
  profileName: 'Profile Name',
  category: 'Category',
  registrationDate: 'Registration Date & Time',
  id: 'ID',
};
